export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vue 3 i18n"])},
  "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A Vue i18n next example using vue-i18n-next"])}
}